import React, { useState, useEffect, useCallback } from "react";

import "./fontawesome";
import Footer from "./modules/shared/component/footer/Footer";

import LoadingSpinner from "./modules/shared/component/spinner/LoadingSpinner";
import AppRouters from "./routes/AppRoutes";
import { ThemeProviderContext } from "./modules/shared/context/ThemeContext/ThemeProviderContext";
import { Theme } from "./modules/shared/definitions/enum";

// Move Loading outside App for clarity
function Loading() {
  return (
    <div>
      <LoadingSpinner />
    </div>
  );
}

function App() {
  // Theme state
  const [theme, setTheme] = useState<Theme>(() => {
    const savedTheme = localStorage.getItem("theme") as Theme;
    return savedTheme ? savedTheme : Theme.LIGHT;
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Use useCallback for stable reference
  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === Theme.DARK ? Theme.LIGHT : Theme.DARK));
  }, []);

  // Loading state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loading />;

  return (
    <ThemeProviderContext.Provider value={theme}>
      <div className="flex flex-col">
        {/* <Header theme={theme} toggleTheme={toggleTheme} /> */}
        <AppRouters theme={theme} toggleTheme={toggleTheme} />
        <Footer />
        {/* This div is only a trigger for creating tailwind classes to be added on css files */}
        <div className="hidden">
          <div className="!cursor-wait"></div>
        </div>
      </div>
    </ThemeProviderContext.Provider>
  );
}

export default App;
